<div class="message-box info" style="width:90%; background-color: #AAD1FF; padding: 0.2rem">
  <mat-card-title><div style="padding: 0.5rem; text-align: left;">News</div></mat-card-title>
  <mat-card-content>

    <div style="display: flex; padding-left: 0.5 rem; padding-right: 0.5rem" *ngIf="showNews1">
      <div style="padding: 0.2rem; padding-left: 0.5 rem; padding-right: 0.5rem">
        <img
        src="/assets/icons8-notizie.svg"
        style="width: 30px"
        matTooltipClass="tooltip-layout"
        />
      </div>
      <div  style="padding-top: 0.3rem; text-align: left">
        <span class="textSubtitle1 textBlack0_54">{{title1}}</span><br />
        <span class="textBlack0_54"  style="text-align: left">{{content1}}</span>
      </div>
    </div>

    <div style="display: flex; padding-left: 0.5 rem; padding-right: 0.5rem" *ngIf="showNews2">
      <div style="padding: 0.2rem">
        <img
        src="/assets/icons8-notizie.svg"
        style="width: 30px"
        matTooltipClass="tooltip-layout"
        />
      </div>
      <div style="padding-top: 0.3rem; text-align: left">
        <span class="textSubtitle1 textBlack0_54"  style="text-align: left">{{title2}}</span><br />
        <span class="textBlack0_54"  style="text-align: left">{{content2}}</span>
      </div>
    </div>

    <div style="display: flex; padding-left: 0.5 rem; padding-right: 0.5rem" *ngIf="showNews3">
      <div style="padding: 0.2rem">
        <img
        src="/assets/icons8-notizie.svg"
        style="width: 30px"
        matTooltipClass="tooltip-layout"
        />
      </div>
      <div style="padding-top: 0.3rem; text-align: left">
        <span class="textSubtitle1 textBlack0_54"  style="text-align: left">{{title3}}</span><br />
        <span class="textBlack0_54"  style="text-align: left">{{content3}}</span>
      </div>
    </div>

</mat-card-content>
</div>
